import { StyleSheet } from 'aphrodite/no-important';
import { media, palette } from 'util/style-helpers';

export const style: any = () => {
  return StyleSheet.create({
    label: {
      textAlign: 'right',
      width: 'fit-content',
      marginBottom: '15px',
      fontSize: '18px',
      lineHeight: '20px',
      [media.desktop]: {
        marginBottom: '0px',
        borderRight: '1px solid white',
      },
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      padding: '0px 20px',
    },

    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      maxWidth: '100%',
      width: 'fit-content',
      justifyContent: 'center',
      alignItems: 'stretch',
      color: 'white',
      margin: '20px auto',
      fontWeight: 'bold',
      [media.desktop]: {
        flexDirection: 'row',
      },
    },
    languageButtons: {
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      fontSize: '20px',
      lineHeight: '22px',
      [media.desktop]: {
        fontSize: '18px',
        lineHeight: '20px',
        justifyContent: 'flex-start',
      },
    },
  });
};

export const buttonStyle: any = (selected: boolean) => {
  return StyleSheet.create({
    button: {
      whiteSpace: 'nowrap',
      color: selected ? palette.white : palette.lightDarkGrey,
      background: selected ? palette.redGradient : palette.white,
      padding: '8px 29px',
      height: '38px',
      ':first-child': {
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
      },
      ':last-child': {
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px',
      },
      ':hover': {
        cursor: 'pointer',
      },
      [media.desktop]: {
        height: 'auto',
        color: selected ? palette.red : palette.white,
        background: 'transparent',
        padding: '0px 20px',
        ':hover': {
          cursor: 'pointer',
          color: palette.red,
        },
        ':first-child': {
          borderTopLeftRadius: '0px',
          borderBottomLeftRadius: '0px',
        },
        ':last-child': {
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
        },
        ':not(:last-child)': {
          borderRight: '1px solid white',
        },
      },
    },
  });
};
